import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './app';
import { AppNotifications } from './notifications/toasts';
import { createWorkspaceQueryClient } from './app/query-client';
import { AppErrorBoundary } from './app/app-error-boundary';
import { getLocale, getTextDirection, setLocale } from './paraglide/runtime.js';
import './index.css';

const locale = getLocale();
setLocale(locale, { reload: false });
document.documentElement.lang = locale;
document.documentElement.dir = getTextDirection();

const themeColor = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
function syncBrowserTheme() {
  themeColor?.setAttribute('content', getComputedStyle(document.documentElement).backgroundColor);
}
syncBrowserTheme();
new MutationObserver(syncBrowserTheme).observe(document.documentElement, {
  attributes: true,
  attributeFilter: ['class'],
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root is missing from index.html');
}

const queryClient = createWorkspaceQueryClient();

createRoot(container).render(
  <StrictMode>
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AppNotifications>
          <App />
        </AppNotifications>
      </QueryClientProvider>
    </AppErrorBoundary>
  </StrictMode>,
);
